import React from 'react';
import { Col, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import LoginForm from './LoginForm';
import OwnerAccessNotice from './OwnerAccessNotice';
import { MARKETPLACE_ENABLED } from '../../helpers/marketplaceEnabled';

const Login = () =>
<>
  <Row className="text-left justify-content-between">
    <Col xs="auto">
      <h5>Iniciar sesión</h5>
    </Col>
    <Col xs="auto">
      <p className="fs--1 text-600">
        ó <Link to="/register">registrar mi condominio</Link>
      </p>
    </Col>
  </Row>
  <LoginForm />
  <OwnerAccessNotice className="mt-3" />
  {MARKETPLACE_ENABLED && (
    <p className="fs--1 text-600 text-center mt-3 mb-0">
      ¿Ofreces servicios para el hogar? <Link to="/register/provider">Regístrate como proveedor</Link>
    </p>
  )}
</>

export default Login;